import { render, staticRenderFns } from "./SidebetNames.vue?vue&type=template&id=687e87b8&"
import script from "./SidebetNames.vue?vue&type=script&lang=js&"
export * from "./SidebetNames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports